import { toast } from 'react-toastify';

const messageManager = {
    config: {
        position: 'bottom-right',
        className: 'overwriteToast',
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 60,
    },
    toastId: null,
    isVisible: false,
    show: function (message) {
        const self = this;
        if (message.type === 'error') {
            self.toastId = toast.error(message.text, this.config);
            self.isVisible = true;
        }
        else {
            self.toastId = toast(message.text, this.config);
            self.isVisible = true;
        }
        setTimeout(() => {
            self.isVisible = false;
        }, 4000)
    }
}

export default messageManager;


// WEBPACK FOOTER //
// ./src/utilities/messageManager.js